<script setup lang="ts">
import lgFullScreen from 'lightgallery/plugins/fullscreen'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgVideo from 'lightgallery/plugins/video'
import lgZoom from 'lightgallery/plugins/zoom'
import Lightgallery from 'lightgallery/vue'
import type { LightGallerySettings } from 'lightgallery/lg-settings'

const props = defineProps<{
  lightgalleryState: ReturnType<typeof useLightgalleryState>
  settings?: LightGallerySettings
}>()

const lightgallerySettings = {
  licenseKey: 'AF7254AF-A0A3-4A66-B67D-2198EF5D3262',
  galleryId: props.lightgalleryState.galleryId,
  speed: 250,
  plugins: [lgThumbnail, lgZoom, lgVideo, lgFullScreen],
  hideBarsDelay: 3210,
  download: false,
  hideScrollbar: true,
  dynamic: true,
  dynamicEl: props.lightgalleryState.dynamicItems.value,
  thumbMargin: 8,
  thumbWidth: 75,
  thumbHeight: '45px',
  mobileSettings: {
    controls: true,
    showCloseIcon: true,
    download: false,
  },
}

const lightgalleryRef = ref()
props.lightgalleryState.setLightgalleryRef(lightgalleryRef)
</script>

<template>
  <Lightgallery
    ref="lightgalleryRef"
    :settings="{
      ...lightgallerySettings,
      ...props.settings,
    }"
    :on-after-open="lightgalleryState.onAfterOpen"
    :on-after-close="lightgalleryState.onAfterClose"
  >
    <slot />
  </Lightgallery>
</template>

<style lang="scss">
@import '~/assets/styles/lib/lightgallery-overrides/variables';
@import 'lightgallery/scss/lightgallery';
@import 'lightgallery/scss/lg-transitions';
@import 'lightgallery/scss/lg-thumbnail';
@import 'lightgallery/scss/lg-zoom';
@import 'lightgallery/scss/lg-video';
@import 'lightgallery/scss/lg-fullscreen';
@import '~/assets/styles/lib/lightgallery-overrides/overrides';
</style>
